import React, { Component } from 'react'
import Select, { components } from 'react-select';

export default class ReactSelect extends Component {

  render() {
    const {...rest} = this.props;
    const CustomSelectStyles = {
      control: (styles, {...props}) => {
        return {
          ...styles,
          borderColor: props.isFocused ? '#00B550' : undefined,
          boxShadow: props.isFocused ? '0 0 0 1px #00B550' : undefined,
          "&:hover": {
            borderColor: "#00B550"
          },
          fontFamily: 'Lato-Regular',
          fontSize: '14px',
          marginBottom: '2px'
        }
      },
      placeholder: (styles, {...props}) => {
        return {
          ...styles,
          fontFamily: 'Lato-Regular',
          fontSize: '14px'
        }
      },
      option: (styles, { data, isDisabled, isFocused, isSelected, ...props}) => {

        let idx = props.options.findIndex(x => x.value == data.value);
        let last = idx == props.options.length - 1;

        let backgroundColor = undefined;
        if (!isSelected && (isFocused || styles['backgroundColor'].toUpperCase() == '#DEEBFF')){
          backgroundColor = '#e5f8ed';
        }
        else if (isSelected){
          backgroundColor = '#00B550';
        }

        return {
          ...styles,
          backgroundColor: backgroundColor,
          borderBottom: last ? undefined : '1px solid #CCCCCC',
          '&:active': {
            backgroundColor: '#e5f8ed',
          },
          '&:hover': {
            backgroundColor: isSelected ? '00B550' : '#e5f8ed',
          },
          fontFamily: 'Lato-Regular',
          fontSize: '14px'
        };
      },
    }

    return (
      <Select
        aria-live="polite"
        styles={CustomSelectStyles}
        {...rest}
      />
    );
  }
}